import ButtonGroupComponent from '@material-ui/core/ButtonGroup'
import React from 'react'

const ButtonGroup = (props) => {
  return <ButtonGroupComponent variant="contained" {...props} />
}

export default ButtonGroup
